module.exports = __webpack_public_path__ + "img/cabbage-posterized-large-charlie.0948a254.png";